document.addEventListener('DOMContentLoaded', () => {
  const modal         = document.getElementById('quick-buy-modal');
  const bodyContainer = document.getElementById('quick-buy-modal-body');

  // Close the modal and clear content
  function closeModal() {
    modal.classList.remove('active');
    modal.setAttribute('aria-hidden', 'true');
    bodyContainer.innerHTML = '';
  }

  // AJAX Add-to-Cart handler
  function handleAjaxAdd(event) {
    event.preventDefault();
    const form = event.target;
    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { 'Accept': 'application/json' }
    })
    .then(res => res.json())
    .then(item => {
      closeModal();
      // Use King theme's cart drawer if available
      if (window.Cart && typeof Cart.openMiniCart === 'function') {
        Cart.openMiniCart();
      } else {
        console.log('Added to cart:', item);
      }
    })
    .catch(err => console.error('Quick-Buy AJAX error:', err));
  }

  // Wire up Quick-Buy buttons
  document.querySelectorAll('.quick-buy-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const prodId   = btn.dataset.productId;
      const variants = JSON.parse(btn.dataset.variants || '[]');
      const template = document.getElementById(`quick-buy-tmpl-${prodId}`);
      if (!template) return;

      // Inject the form HTML
      bodyContainer.innerHTML = template.innerHTML;

      // Show modal
      modal.classList.add('active');
      modal.setAttribute('aria-hidden', 'false');

      // Find hidden variant-id input & each option <select>
      const idInput = bodyContainer.querySelector('input[name="id"]');
      const selects = bodyContainer.querySelectorAll('.qb-option-select');

      // Update hidden id based on dropdown values
      function updateVariantId() {
        const chosen = Array.from(selects).map(s => s.value);
        const match  = variants.find(v =>
          v.options.every((opt, i) => opt === chosen[i])
        );
        if (match) idInput.value = match.id;
      }

      // Initialize & re-run on change
      updateVariantId();
      selects.forEach(s => s.addEventListener('change', updateVariantId));

      // Attach AJAX submission
      const form = bodyContainer.querySelector('.quick-buy-form');
      if (form) form.addEventListener('submit', handleAjaxAdd);
    });
  });

  // Close modal on overlay or “×”
  modal.querySelector('.modal-overlay').addEventListener('click', closeModal);
  modal.querySelector('.modal-close').addEventListener('click', closeModal);
});
